import { render, staticRenderFns } from "./PageFooterPlain.vue?vue&type=template&id=3b007b1a&"
import script from "./PageFooterPlain.vue?vue&type=script&lang=js&"
export * from "./PageFooterPlain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports